<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Detalle Campo Deportivo"
          icon="fas fa-coins"
          btn_name="Detalle Campo Deportivo"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
        />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">          
          <cSelectForm
            label="Deporte"
            placeholder="Seleccione deporte"
            :options="data_sports"
            :value.sync="sport_fieldxsport.sport_id"
          />
          <cSelectForm
            label="Campo Deportivo"
            placeholder="Seleccione campo deportivo"
            :options="data_sports_fields"
            :value.sync="sport_fieldxsport.sport_field_id"
          />

          <!-- <cSelectForm
            label="Tarifa"
            placeholder="Seleccione tarifa"
            :options="data_rates"
            :value.sync="sport_fieldxsport.rates_price"
          /> -->
          
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="sport_fieldxsport.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Detalle Deportivo'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "sport_field_name", label: "Campo deportivo", _style: "width:20%;" },
  { key: "sport_name", label: "Deporte", _style: "width:20%;" },
  // { key: "rate_price", label: "Tarifa", _style: "width:20%;" },
  { key: "state", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../shared/datatable/Table.vue";
import CModalForm from "../shared/modals/cModalForm.vue";
import cModalDelete from "../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import { bus } from "../../main";
import { CSwitch } from "@coreui/vue-pro";
import CSwitchVue from "../shared/switch/CSwitch.vue";
// import cSelect from "../shared/inputs/cSelect.vue";
import cSelectForm from "../shared/inputs/cSelect.vue";


export default {
  components: { CTableWrapper, CModalForm, cModalDelete, CSwitchVue, cSelectForm },
  data() {
    return {
      prefix: "sports_fieldsxsports",
      fields,
      data: [],
      data_sports: [],
      data_sports_fields: [],
      // data_rates: [],

      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      sport_fieldxsport: {
        id: "",
        sport_id:"",
        // rates_id:"",
        sport_field_id:"",
        sport_name:"",
        sport_field_name:"",
        // rate_price:"",
        company: this.$store.getters.get_company,
        state: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      // dataStore: [],
    };
  },
  computed: {
    cpStatus: function () {
      if (this.sport_fieldxsport.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (this.sport_fieldxsport.sport_id != "") 
      return false;
      return true;
    },
  },
  created() {
    this.mtd_getdata();
    this.mtd_getsports();
    this.mtd_getsportsfields();
    // this.mtd_getrates();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtd_getsports:function(){
      this.get({
        url: this.$store.getters.get__url + "/sports_fieldsxsports/1",
        token: this.$store.getters.get__token,
      })
      .then((response) => {
          response.data.forEach((element) => {
            this.data_sports.push({
              label: element.name,
              value: element.id,
            });
          });
        })
        .catch((errors) => {});
    },
    mtd_getsportsfields:function(){
      let url;
      if(this.$store.getters.get__user_id == 1){
        url = this.$store.getters.get__url + "/sports_fieldsxsports/sportField/"+this.$store.getters.get__user_id+"/0";
      }else{
        url =this.$store.getters.get__url +"/sports_fieldsxsports/sportField/"+this.$store.getters.get__user_id+"/"+this.$store.getters.get_campu.value;
      }
      this.get({
        url: url,
        token: this.$store.getters.get__token,
      })
      .then((response) => {
          response.data.forEach((element) => {
            this.data_sports_fields.push({
              label: element.name,
              value: element.id,
            });
          });
        })
        .catch((errors) => {});
    },

    mtd_getdata: function () {
      let url;
      if(this.$store.getters.get__user_id == 1){
        url = this.$store.getters.get__url + "/" + this.prefix+"/index/"+this.$store.getters.get__user_id+"/0";
      }else{
        url =this.$store.getters.get__url + "/" + this.prefix+"/index/"+this.$store.getters.get__user_id+"/"+this.$store.getters.get_campu.value;
      }
      this.get({
        // url: this.$store.getters.get__url + "/" + this.prefix+"/index/"+this.$store.getters.get__user_id+"/"+this.$store.getters.get_campu.value,
        url: url,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.sports_fieldsxsports;
          let index = 1;
          this.data.forEach((arr)=>{
            arr.index = index;
            index++;
          })
        })
        .catch((errors) => {
          // Manejar errores
        });
    },

    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo Detalle por Campo")
        : (this.modal.title = "Editar Detalle por Campo");
      action == "store"
        ? (this.sport_fieldxsport = {
            id: "",
            sport_id:"",
            // rates_id:"",
            sport_field_id:"",
            state: "",
          })
        : (this.sport_fieldxsport = {...this.sport_fieldxsport});
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.sport_fieldxsport,
      })
        .then((response) => {
          if(response.data.state==1){
              Swal.fire({
                      title: "Deporte ya resgistrado en el campo deportivo",
                      icon: "warning"
              });
          }else{
            let color = "success";
            let message = "";
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              this.mtd_getdata();
            } else {
            
              let updated = response.data.data;
              let index = this.data.findIndex(sport_fieldxsport => sport_fieldxsport.id === updated.id);
              if (index !== -1) {
                this.$set(this.data, index, updated);
              }
              message = "EDITADO CORRECTAMENTE";
              this.mtd_getdata();
            }
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
              name: "",
            };
            // this.employee = { id: "", day: "", shift: "", price: "", state: 0 }; 

            bus.$emit("alert", {
              color: color,
              message: message,
            });
          }
        })
        .catch((errors) => {
          bus.$emit("alert", {
            color: "danger",
            message: errors,
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.sport_fieldxsport = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.id,
        },
      })
        .then((response) => {
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };

          bus.$emit("alert", {
            color: "success",
            message: "ELIMINADO CORRECTAMENTE",
          });
        })
        .catch((errors) => {});
    },
    changeSwitch: function (payload) {
      this.sport_fieldxsport.state = payload == true ? 1 : 0;
    },
  },
  destroyed() {
    // console.log(this.dataStore);
    // this.$store.commit("mt_set_datacampus", this.dataStore);
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>